import React, { useState, useEffect } from "react";
import ClearIcon from "@mui/icons-material/Clear";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import FormLabel from "@mui/material/FormLabel";
import axios from "axios";

import Modal from "../components/common/CommonModal";
import CreditCustomerList from "../components/common/CreditCustomerList";

const AccountSelector = ({
  accounts,
  searchAccountTerm,
  setSearchAccountTerm,
  value,
  setValue,
  onSelectedAccountParent,
  onSelectedAccountNameParent,
  onSelectedAccountPhoneParent,
  setSelectedAccountToAPI,
  initialAccountData,
}) => {
  const COMPANY_CODE = localStorage.getItem("companyCode") || "-";
  const API_PATHS = localStorage.getItem("apiPaths")
    ? JSON.parse(localStorage.getItem("apiPaths"))
    : [];

  const [inputValue, setInputValue] = useState("-");
  const [filteredAccounts, setFilteredAccounts] = useState(accounts);
  const [filteredSearchedAccounts, setFilteredSearchedAccounts] =
    useState(null);
  const [isDropdownOpen, setDropdownOpen] = useState(false);
  const [isModalOpen, setModalOpen] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [accountListFromAPI, setAccountListFromAPI] = useState(null);
  // const [searchAccountTerm, setSearchAccountTerm] = useState(null);
  const [loading, setLoading] = useState(false);

  // const [value, setValue] = useState("ALL");

  useEffect(() => {
    //fetchAccountList();
  }, []);

  useEffect(() => {
    if (initialAccountData && initialAccountData.ACCOUNT) {
      console.log("Setting initial account:", initialAccountData);
      setSelectedAccount(initialAccountData);
      setInputValue(
        `${initialAccountData.ACCOUNT} - ${initialAccountData.DESCRIPTION}`,
      );
      onSelectedAccountParent(initialAccountData.ACCOUNT);
      onSelectedAccountNameParent(initialAccountData.DESCRIPTION);
      // onSelectedAccountPhoneParent(initialAccountData.DESCRIPTION);
    }
  }, [initialAccountData]);

  useEffect(() => {
    if (!searchAccountTerm?.trim()) {
      setFilteredSearchedAccounts(filteredAccounts);
    } else {
      const term = searchAccountTerm.toLowerCase();
      setFilteredSearchedAccounts(
        filteredAccounts?.filter(
          (acc) =>
            acc.ACCOUNT?.toLowerCase().includes(term) ||
            acc.DESCRIPTION?.toLowerCase().includes(term),
        ),
      );
    }
  }, [searchAccountTerm, filteredAccounts]);

  const fetchAccountList = async (searchTerm = "-") => {
    let company_code_from_local_storage = localStorage.getItem("companyCode")
      ? localStorage.getItem("companyCode")
      : "-";

    let currentSelectedDepartment = localStorage.getItem(
      "currentSelectedDepartment",
    )
      ? localStorage.getItem("currentSelectedDepartment")
      : "-";

    let apiPaths_from_local_storage = localStorage.getItem("apiPaths")
      ? JSON.parse(localStorage.getItem("apiPaths"))
      : "-";
    let apiUrl = `${apiPaths_from_local_storage[0].API_CONFIG}/api/CRMAccountList/${COMPANY_CODE}/ACCOUNTLIST/${currentSelectedDepartment}/${value}/-/${
      searchTerm && searchTerm.trim() ? searchTerm.trim() : "-"
    }`;

    try {
      setLoading(true);
      const response = await axios.get(apiUrl);
      const data = response.data;
      // console.log("fetched Account List :", data);
      setAccountListFromAPI(data);
    } catch (err) {
      console.error("Error while fetching jobist", err);
      setAccountListFromAPI([]);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (event) => {
    setValue(event.target.value);
  };

  useEffect(() => {
    setFilteredAccounts(accounts);
    // console.log("accounts::", accounts);
  }, [accounts]);

  // Filter accounts when typing
  useEffect(() => {
    if (!inputValue.trim()) {
      setFilteredAccounts(accounts);
    } else {
      setFilteredAccounts(
        accounts?.filter(
          (acc) =>
            acc.DESCRIPTION?.toLowerCase().includes(inputValue.toLowerCase()) ||
            acc.ACCOUNT?.toLowerCase().includes(inputValue.toLowerCase()),
        ),
      );
    }
  }, [inputValue, accounts]);

  // Search accounts via API as the user types (debounced)
useEffect(() => {
  // 1. Don't search if an account is already selected
  if (selectedAccount) return;

  // 2. Don't search if input is empty, whitespace, or default "-"
  const cleanedInput = inputValue?.trim();
  if (!cleanedInput || cleanedInput === "-") {
    setAccountListFromAPI(null); // Clear previous search results if any
    return;
  }

  // Optional: Only search after user types at least 2 or 3 characters
  // if (cleanedInput.length < 2) return;

  const timer = setTimeout(() => {
    fetchAccountList(cleanedInput);
  }, 350);

  return () => clearTimeout(timer);
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [inputValue, selectedAccount]);

  // console.log("filteredAccounts:", filteredAccounts);
  // console.log("selectedAccount:", selectedAccount);

  // Open modal on F2 press
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === "F2") {
        e.preventDefault();
        setModalOpen(true);
      }
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const clearAccounts = () => {
    setInputValue("-");
    setSelectedAccount(null);
    setAccountListFromAPI(null);
    onSelectedAccountParent("-");
  };

  // Called when a user picks an account from the search dropdown
  const handleAccountSearchSelect = (acc) => {
    setSelectedAccount(acc);
    setInputValue(`${acc.ACCOUNT} - ${acc.DESCRIPTION}`);
    setDropdownOpen(false);
    onSelectedAccountParent(acc.ACCOUNT);
    onSelectedAccountNameParent(acc.DESCRIPTION);
    onSelectedAccountPhoneParent(acc.Contact_No);
  };

  // const sendAccountToParent = (acc) => {
  //   console.log("sendAccountToParent acc", acc);
  //   onSelectedAccountParent(acc);
  // };

  const formatBalance = (balance) =>
    new Intl.NumberFormat("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(balance);

  const handleCustomerSelect = (data) => {
    console.log("data from new f2:", data);
    setSelectedAccount(data);
    onSelectedAccountParent(data.ACCOUNT);
    onSelectedAccountNameParent(data.DESCRIPTION);
    onSelectedAccountPhoneParent(data.Contact_No);
    setModalOpen(false);
  };

  return (
    <div className="relative w-[380px]">
      {/* Input Field */}
      <div className="flex justify-between items-center bg-white  w-full border border-gray-300 rounded px-3 py-1">
        {selectedAccount ? (
          <div
            onClick={() => setDropdownOpen(true)}
            className="flex flex-col w-full cursor-text"
          >
            <div className="flex justify-between items-center">
              <span className=" text-gray-900 text-sm">
                {selectedAccount.ACCOUNT}
              </span>
              <span
                className={`bg-[#FEFCE8] px-1 py-[0.25] border border-yellow-300 rounded-md text-[0.65rem]  font-semibold mr-2 mb-2 ${
                  Number(selectedAccount.BALANCE) > 0
                    ? "text-green-600"
                    : "text-red-600"
                }`}
              >
                {selectedAccount.BALANCE}
              </span>
            </div>
            <span className="text-gray-500 text-xs truncate">
              {selectedAccount.DESCRIPTION}
            </span>
          </div>
        ) : (
          <input
            type="text"
            value={inputValue === "-" ? "" : inputValue}
            placeholder="Select or type Account"
            onChange={(e) => setInputValue(e.target.value)}
            onFocus={() => setDropdownOpen(true)}
            autoFocus
            onBlur={() => setTimeout(() => setDropdownOpen(false), 200)}
            className="outline-none focus:outline-none focus:ring-0 border-none w-full bg-white"
          />
        )}

        {inputValue !== "" && inputValue !== "-" && (
          <button className="rounded text-gray-800" onClick={clearAccounts}>
            <ClearIcon fontSize="small" />
          </button>
        )}
      </div>

      {/* Search Dropdown (results from CRMAccountList API) */}
      {isDropdownOpen && !selectedAccount && (
        <ul
          className="absolute bg-white border border-gray-300 w-full mt-1 max-h-44 shadow-lg overflow-y-auto z-10"
          onMouseDown={(e) => e.preventDefault()}
        >
          {loading && (
            <li className="px-3 py-2 text-sm text-gray-400">Searching...</li>
          )}

          {!loading && accountListFromAPI?.length === 0 && (
            <li className="px-3 py-2 text-sm text-gray-400">
              No accounts found
            </li>
          )}

          {!loading &&
            accountListFromAPI?.map((acc, i) => (
              <li
                key={acc.ACCOUNT ?? i}
                onClick={() => handleAccountSearchSelect(acc)}
                className="px-3 py-2 text-sm hover:bg-blue-100 cursor-pointer"
              >
                <div className="flex flex-col border-b pb-1">
                  <div className="flex justify-between items-center">
                    <span className=" text-gray-900 text-sm">
                      {acc.ACCOUNT}
                    </span>
                    <span
                      className={`bg-[#FEFCE8] px-1 py-[0.25] border border-yellow-300 rounded-md text-[0.65rem]  font-semibold mr-2 mb-2 ${
                        Number(acc.BALANCE) > 0
                          ? "text-green-600"
                          : "text-red-600"
                      }`}
                    >
                      {acc.BALANCE}
                    </span>
                  </div>
                  <span className="text-gray-500 text-xs  truncate">
                    {acc.DESCRIPTION}
                  </span>
                </div>
              </li>
            ))}
        </ul>
      )}

      {isModalOpen && (
        <Modal
          isOpen={isModalOpen}
          onClose={() => setModalOpen(false)}
          title={"Statement Account"}
          size="xxl"
          header={true}
        >
          <CreditCustomerList
            defaultType="All"
            handleCustomerSelect={handleCustomerSelect}
          />
          {/* <ProductListing/> */}
        </Modal>
      )}
    </div>
  );
};

export default AccountSelector;